import { ReactNode } from 'react'

import { BannerContainer, BannerTitle } from './styles'

interface IBannerProps {
  backgroundColor: string
  children: ReactNode
}

export function Banner({ children, backgroundColor }: IBannerProps) {
  return (
    <BannerContainer backgroundColor={backgroundColor}>
      <BannerTitle>{children}</BannerTitle>
    </BannerContainer>
  )
}
